// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';                 // Tailwind + custom styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';

// ✅ Configure AWS Amplify (Cognito, etc.)
Amplify.configure({
  ...awsconfig,
  // If you ever need cookies for auth, you can uncomment and adjust:
  // aws_cognito_cookie_storage: {
  //   domain: 'localhost',
  //   path: '/',
  //   expires: 365,
  //   secure: false,
  //   sameSite: 'lax',
  // },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error("Error: Root element with id 'root' not found in index.html.");
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
